export function el<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Record<string, string | boolean | undefined> = {}, ...children: Array<Node | string | null | undefined | false>): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === undefined || v === false) continue;
    if (k === 'class') e.className = String(v);
    else if (k === 'text') e.textContent = String(v);
    else e.setAttribute(k, v === true ? '' : String(v));
  }
  for (const c of children) if (c != null && c !== false) e.append(c);
  return e;
}

export function clear(node: HTMLElement): void { while (node.firstChild) node.firstChild.remove(); }

export const PROVIDER_LABEL: Record<string, string> = { aws: 'AWS', gcp: 'GCP', azure: 'Azure', cloudflare: 'Cloudflare' };

export function pct(x: number): string { return `${Math.round(x * 100)}%`; }
export function votes(x: number): string { return x >= 10 ? String(Math.round(x)) : x.toFixed(1).replace(/\.0$/, ''); }
